/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-03-24 14:00:21
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-04-27 12:52:08
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/TimeAndDatePickField/Components/TimePickerModal/index.tsx
 */
import React, { useEffect, useState } from 'react';
import moment, { Moment } from 'moment';

import { Modal, Button } from '@/src/components/Antd';
import { SalesChannelVersionDatePicker } from '@/src/components';

import styles from './style.module.less';

type Props = {
  visible: boolean;
  onCancel: () => void;
  afterClose: () => void;
  onSubmit: (start: Moment, end: Moment) => void;
  occupiedRanges: Array<{
    beginDate: string;
    beginTime: string;
    endDate: string;
    endTime: string;
  }>;
  timezoneGmt: string;
  date: {
    startTime: string;
    endTime: string;
  };
};

function TimePickerModal({
  visible,
  onCancel,
  onSubmit,
  afterClose,
  occupiedRanges,
  timezoneGmt,
  date,
}: Props) {
  const [startTime, setStartTime] = useState(date.startTime);
  const [endTime, setEndTime] = useState(date.endTime);

  const handleChangeTime = (begin: Moment, end: Moment) => {
    setStartTime(begin ? begin.format('YYYY-MM-DD H:m') : null);
    setEndTime(end ? end.format('YYYY-MM-DD H:m') : null);
  };

  const inner_trasnformTime = (t: string) => {
    const m = moment(t);
    const date = t ? m.format('YYYY-MM-DD') : '';
    const time = t ? m.format('H:m') : '';
    return { date, time };
  };

  const startTimeString = inner_trasnformTime(startTime);
  const endTimeString = inner_trasnformTime(endTime);

  useEffect(() => {
    setStartTime(date.startTime);
    setEndTime(date.endTime);
  }, [date]);
  return (
    <Modal
      width={600}
      title={'Edit Campaign Time'}
      visible={visible}
      onCancel={onCancel}
      afterClose={afterClose}>
      <div className={styles.container}>
        <div className={styles.title}>
          Please note that campaign time period cannot overlap.
        </div>
        <div className={styles.timePicker}>
          <SalesChannelVersionDatePicker
            enableDateCheck
            style={{ width: '536px', height: '32px', borderRadius: '4px' }}
            data={{
              timezoneGmt,
              occupiedRanges,
              specifiedDate: {
                beginDate: startTimeString.date,
                beginTime: startTimeString.time,
                endDate: endTimeString.date,
                endTime: endTimeString.time,
              },
            }}
            onChange={handleChangeTime}></SalesChannelVersionDatePicker>
        </div>
        <div className={styles.footer}>
          <Button onClick={onCancel} className={styles.btn}>
            Discard
          </Button>
          <Button
            type={'primary'}
            onClick={onSubmit.bind(this, startTime, endTime)}
            className={styles.btn}>
            Confirm
          </Button>
        </div>
      </div>
    </Modal>
  );
}

export default TimePickerModal;
